export default __webpack_public_path__ + "static/media/BLR10.6cb56cfe.jpg";